import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import WithDrawMenu from './WithDrawMenu';
import { DeleteUserWalletWithDrawService, GetUserWalletWithDrawService } from '../../services/WithDrawRequestServices';

function WithDrawRequestList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)

  const [step, setstep] = useState("Pending")

  let stages = ['Pending','Approved','Rejected']


  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})

  const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })

  useEffect(() => {
    getdata()
  }, [step, page])

  async function getdata() {
    const response = await GetUserWalletWithDrawService(page, search?.from_date1, search?.to_date1,step,'')
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetUserWalletWithDrawService(1, search?.from_date1, search?.to_date1,step,'')
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })
    setpage(1)
    const response = await GetUserWalletWithDrawService(1, '', '',step,'')
    setdata(response?.data)
  }

  async function deleteData() {
    const response = await DeleteUserWalletWithDrawService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }

  function formatToCurrency(amount){
   return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(parseInt(amount)).split('.')[0]
  }

 
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <WithDrawMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className=' items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Wallet WithDraw Request ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>
             {(roles?.includes('wfh') || roles?.includes('admin')) &&
              <div className='mt-1 md:mt-0'>
              <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigator('create')} />
              </div>}
            </div>
           </div>
 

            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 onClick={()=>{setstep(s);setpage(1)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>


          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <div className='md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[100px] w-[100px]  md:min-w-[100px]  md:w-[100px]  px-2 py-1 font-[600] text-slate-800 border-r'>Amount</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1 font-[600] text-slate-800 border-r'>Description </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Handled By </h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[150px] w-[150px]  md:min-w-[150px]  md:w-[150px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className=' text-[11px] break-word min-w-[100px] w-[100px]  md:min-w-[100px] md:w-[100px] px-2 py-1 border-r'>
                        <span className='font-bold'>{formatToCurrency(d?.amount)}</span>

                        {d?.file && <h6 onClick={()=>openFile(d?.file)} className='text-[10px] font-[800] underline text-blue-600 cursor-pointer'>View File</h6>}
                      
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px] px-2 py-1 font-[500] border-r'>
                        {d?.description}
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.updated_by?.name}
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1  border-r'>
                        {d?.remarks}
                      </h6>
                      <h6 className='flex   break-word  min-w-[150px] w-[150px]  md:min-w-[150px]  md:w-[20px] px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LLL')}  </h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px] px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />
                      </h6>
                    </div>))}
                </div>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default WithDrawRequestList